
import { tdx_request, tdx_response } from "../../tdx_proto/bundle";
import { getConnectionPool } from '../../core/connectionPool';
import { initAlertSdk } from '../../init/alertsSdk';
import { hashString } from "../../utils/hash";
import { initTdx } from "../../init/sdkTdx";

export class RuleSets {
    name: string;
    enabled: boolean;
    constructor(name: string, enabled: boolean) {
        this.name = name;
        this.enabled = enabled;
    }
}

export class AlertType {
    id: number;
    name: string;
    enabled: boolean;
    description: string;

    constructor(id: number, name: string, enabled: boolean, description: string) {
        this.id = id;
        this.name = name;
        this.enabled = enabled;
        this.description = description;
    }

}


export class Alerts {
    constructor() {
    }
    async create_alert(category: string, sub_category: string, alert: string): Promise<String | void> {
        // console.log("Timestamp in create_alert: ", Math.floor(Date.now() / 1000));
        const pool = await getConnectionPool();
        const pin = pool.getPin();
        const data = pool.getToken();
        const client = await initAlertSdk();

        let times = 10;
        while (client.is_open() == false && times >= 0) {
            // console.log('🔄 Waiting for WebSocket to open...');
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 100));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }

        let add_type = tdx_request.Add_Type.Add_Alert;

        if (sub_category === undefined && alert === undefined) {
            add_type = tdx_request.Add_Type.Add_Category;
        }
        if (sub_category !== undefined && alert === undefined) {
            add_type = tdx_request.Add_Type.Add_SubCategory;
        }

        const req = tdx_request.Request.create(
            {
                crateAlert: tdx_request.CreateAlert.create({
                    category: category,
                    subCategory: sub_category,
                    alert: alert,
                    pin: pin,
                    addType: add_type,
                    data: data
                })
            }
        );

        // console.log("Timestamp before sending request: ", Math.floor(Date.now() / 1000));
        const res = await client.sendAndWaitForAlerts(req);
        // console.log('📨 CreateAlert Response:', res);
        if (!res.createAlert || res.createAlert.result.Status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to create alert(${res.createAlert.result.Status})`);
        }
        // let summary = res.createAlert.summary;
        // console.log("Alert created with summary: ", summary);
        // console.log("✅ Response ",res);
        client.close();
        return;
    }

    async delete_alert(category: string, sub_category: string, alert: string): Promise<void> {
        // console.log("Timestamp in delete_alert: ", Math.floor(Date.now() / 1000));
        const pool = await getConnectionPool();
        const pin = await hashString(pool.getPin());
        const data = pool.getToken();
        const client = await initAlertSdk();
        let times = 10;
        // console.log("Timestamp before waiting for WebSocket: ", Math.floor(Date.now() / 1000));
        while (client.is_open() == false && times >= 0) {
            console.log('🔄 Waiting for WebSocket to open...');
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 100));

        }
        // console.log("Timestamp after waiting for WebSocket: ", Math.floor(Date.now() / 1000));
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }

        let delete_type = tdx_request.Delete_Type.Delete_Alert;

        if (sub_category === undefined && alert === undefined) {
            delete_type = tdx_request.Delete_Type.Delete_Category;
        }
        if (sub_category !== undefined && alert === undefined) {
            delete_type = tdx_request.Delete_Type.Delete_SubCategory;
        }

        const req = tdx_request.Request.create(
            {
                deleteAlert: tdx_request.DeleteAlert.create({
                    category: category,
                    subCategory: sub_category,
                    alert: alert,
                    pin: pin,
                    deleteType: delete_type,
                    data: data
                })
            }
        );


        // console.log("Timestamp before sending request: ", Math.floor(Date.now() / 1000));
        const res = await client.sendAndWaitForAlerts(req);
        // console.log('📨 DeleteAlert Response:', res);
        client.close();
        // console.log("✅ Response ",res);
        if (!res.deleteAlert || res.deleteAlert.result.Status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to create alert(${res.deleteAlert.result.Status})`);
        }
        return;

    }

    async list_alerts(category?: string, sub_category?: string): Promise<RuleSets[]> {
        const pool = await getConnectionPool();
        const pin = pool.getPin();
        const data = pool.getToken();
        const client = await initAlertSdk();

        let times = 10;
        while (client.is_open() == false && times >= 0) {
            // console.log('🔄 Waiting for WebSocket to open...');
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 100));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }

        let list_type = tdx_request.List_Type.List_Alerts;

        if (category === undefined) {
            list_type = tdx_request.List_Type.List_Category;
        }

        if (category !== undefined && sub_category === undefined) {
            list_type = tdx_request.List_Type.List_SubCategory;
        }

        const req = tdx_request.Request.create({
            listAlerts: tdx_request.ListAlerts.create({
                category: category,
                subCategory: sub_category,
                pin: pin,
                listType: list_type,
                data: data
            })
        }
        );
        const res = await client.sendAndWaitForAlerts(req);
        // console.log("✅ Response ",res);
        client.close();
        if (!res.listAlerts || res.listAlerts.result.Status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to list alerts(${res.listAlerts.result.Status})`);
        }
        let alerts = res.listAlerts.alerts;
        let enabled = res.listAlerts.enabled;
        let result = [];

        for (let i = 0; i < alerts.length; i++) {
            const ruleset = new RuleSets(alerts[i], enabled[i]);
            result.push(ruleset);
        }
        return result;
    }

    async update_alert(category: string, sub_category: string, alert: string, pause: boolean, resume: boolean, type: number): Promise<void> {
        const pool = await getConnectionPool();
        const pin = pool.getPin();
        const data = pool.getToken();
        const client = await initAlertSdk();
        let times = 10;
        while (client.is_open() == false && times >= 0) {
            // console.log('🔄 Waiting for WebSocket to open...');
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 100));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }

        let update_type = tdx_request.Update_Type.Update_Alert;
        if (type == 0) {
            update_type = tdx_request.Update_Type.Update_Category;
        }
        if (type == 1) {
            update_type = tdx_request.Update_Type.Update_SubCategory;
        }

        const req = tdx_request.Request.create({
            updateAlert: tdx_request.UpdateAlert.create({
                category: category,
                subCategory: sub_category,
                alert: alert,
                pin: pin,
                updateType: update_type,
                pause: pause,
                resume: resume,
                data: data
            })
        }
        );
        const res = await client.sendAndWaitForAlerts(req);
        // console.log("✅ Response ",res);
        client.close();
        if (!res.updateAlert || res.updateAlert.result.Status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to list alerts(${res.updateAlert.result.Status})`);
        }
        return;
    }

    async list_only_alerts(category: string, subCategory: string): Promise<AlertType[]> {
        const pool = await getConnectionPool();
        const pin = pool.getPin();
        const data = pool.getToken();
        const client = await initAlertSdk();
        let times = 10;
        while (client.is_open() == false && times >= 0) {
            // console.log('🔄 Waiting for WebSocket to open...');
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 100));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }
        const req = tdx_request.Request.create({
            listAlerts: tdx_request.ListAlerts.create({
                category: category,
                subCategory: subCategory,
                pin: pin,
                listType: tdx_request.List_Type.List_Alerts,
                data: data
            })
        }
        );
        const res = await client.sendAndWaitForAlerts(req);
        // console.log("✅ Response ",res);
        client.close();
        if (!res.listAlerts || res.listAlerts.result.Status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to list alerts(${res.listAlerts.result.Status})`);
        }
        // return res.listAlerts.alerts;
        let alerts = res.listAlerts.alerts;
        let enabled = res.listAlerts.enabled;
        let summaries = res.listAlerts.summary;
        let result = [];
        for (let i = 0; i < alerts.length; i++) {
            const ruleset = new AlertType(i, alerts[i], enabled[i], summaries[i]);
            result.push(ruleset);
        }

        return result;
    }
    async startConversion(fileFullPath: string, dstFileType: string): Promise<[string, number | Long]> {
        const pool = await getConnectionPool();
        const pin = await hashString(pool.getPin());
        const data = pool.getToken();
        const client = await initTdx();
        let times = 10;
        while (client.is_open() == false && times >= 0) {
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 1000));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }
        const req = tdx_request.Request.create({
            id: null,
            startConversion: tdx_request.StartConversion.create({
                fileFullPath: fileFullPath,
                destType: dstFileType,
                pin: pin,
                data: data,
                typeOfPath: 0
            })
        });
        const res = await client.sendAndWait(req);
        client.close();
        if (!res.startConversion || res.startConversion.status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to conertion of file(${res.startConversion.status})`);
        }
        return [res.startConversion.fileName, res.startConversion.size];
    }

    async getChunkFromYSentinel(fileName: string, offset: number | Long): Promise<Uint8Array> {
        const pool = await getConnectionPool();
        const pin = await hashString(pool.getPin());
        const data = pool.getToken();
        const client = await initTdx();
        let times = 10;
        while (client.is_open() == false && times >= 0) {
            times -= 1;
            await new Promise(resolve => setTimeout(resolve, 1000));

        }
        if (times < 0) {
            throw new Error("Connection Failed. Please try again.");
        }
        const req = tdx_request.Request.create({
            id: null,
            getChunkFromYSentinel: tdx_request.GetChunkFromYSentinel.create({
                pin: pin,
                data: data,
                fileName: fileName,
                offset: offset,
            })
        });
        const resp = await client.sendAndWait(req);
        client.close();
        if (!resp.getChunkFromYSentinel || resp.getChunkFromYSentinel.status !== tdx_response.Status.SUCCESS) {
            throw new Error(`Failed to download converted file(${resp.getChunkFromYSentinel.status})`);
        }
        return resp.getChunkFromYSentinel.data;
    }
};


